<template>
    <div class="container is-fluid">
        <div class="columns" style="padding-top: 100px;">
            <div class="column">
                <app-table></app-table>
            </div>
        </div>
    </div>
</template>

<script>
    import HistoryTable from './HistoryTable'
    export default {
        components: {
            appTable: HistoryTable
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/History/HistoryList.vue